'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FactboxHeader = require('./FactboxHeader');

var _FactboxHeader2 = _interopRequireDefault(_FactboxHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FactboxHeader2.default;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-factbox/lib/cjs/FactboxHeader/index.js
 ** module id = 515
 ** module chunks = 1
 **/